module.exports = __webpack_public_path__ + "media/images/icons/icon-question-mark-816759a62cd4042e59931a3750e5bc8c.svg";